import React from "react";
import { bind } from "decko";

import { Popover, Overlay } from 'react-bootstrap';

export default class OptionPopoverBtn extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            show: false,
            target: null,
        };
    }

    @bind
    onBtnClick (e) {
        e.stopPropagation();
        e.preventDefault();
        this.setState({
            show: !this.state.show,
            target: e.target,
        });
    }

    @bind
    onClickOption (option) {
        this.setState({
            show: false,
        });
        this.props.onSelectOption(option);
    }

    @bind
    onOverlayHide () {
        this.setState({
            show: false,
        });
    }

    renderOverlay () {

        let optionElements = this.props.options.map((option) => (
            <td key={option}>
                <a className="list-group-item"
                    onClick={() => this.onClickOption(option)}>
                    {option}
                </a>
            </td>
        ));

        const columns = this.props.columns || 99;
        let optionRows = [];
        for (let i=0; i<optionElements.length; i+=columns) {
            optionRows.push(
                <tr key={i}>
                    {optionElements.slice(i, i+columns)}
                </tr>
            );
        }

        return (
            <Overlay
                onHide={this.onOverlayHide}
                show
                rootClose
                target={this.state.target}
                placement={this.props.placement}
                container={this.props.container || document.getElementById("root")}
            >
                <Popover id="option-picker">
                    <table className="table table-options-container text-capitalize">
                        <tbody>
                            {optionRows}
                        </tbody>
                    </table>
                </Popover>
            </Overlay>
        );
    }

    render () {

        const overlay = this.state.show ? this.renderOverlay() : null;
        const className = this.props.className || "btn btn-default btn-lg";

        return (
            <div>
                <button style={{position: "relative"}}
                    onClick={this.onBtnClick}
                    className={className}>
                    {this.props.children}
                </button>
                {overlay}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/OptionPopoverBtn.js